import { formatPhoneAsYouType } from '@shared/lib/phone';
import { Input } from 'antd';

import type { InputProps } from 'antd';
import type { CountryCode } from 'libphonenumber-js';

type PhoneInputProps = Omit<InputProps, 'onChange' | 'value'> & {
  value?: string;
  onChange?: (value: string) => void;
  country?: CountryCode;
};

/**
 * Инпут для телефонов с форматированием as-you-type через libphonenumber-js.
 *
 * Контролируемый: AntD Form передаёт `value` + `onChange`. На каждый
 * keystroke прогоняем строку через `formatPhoneAsYouType`, чтобы видеть
 * человекочитаемый формат (`+998 90 123 45 67`) сразу при наборе.
 *
 * Сабмит ожидает, что родитель сконвертирует значение в E.164 через `toE164`
 * перед отправкой на бэк.
 */
export function PhoneInput({ value = '', onChange, country, ...rest }: PhoneInputProps) {
  return (
    <Input
      {...rest}
      value={value}
      inputMode="tel"
      autoComplete="tel"
      onChange={(e) => {
        const formatted = formatPhoneAsYouType(e.target.value, country);
        onChange?.(formatted);
      }}
    />
  );
}
